export default {
  paid: 'จ่ายแล้ว',
  pendingPayment: 'รอชำระเงิน',
  seeOpd: 'ดูข้อมูล OPD',
  seeDoctorInfo: 'ดูข้อมูลแพทย์',
  searchNoNamDoctor: 'ค้นหารหัสพนักงาน ชื่อแพทย์',
  staffNo: 'รหัสพนักงาน',
  title: {
    opdReport: 'รายการ OPD',
    formulaAndTreadment: 'รายการสินค้า สูตรยา และการรักษา',
    physicalExaminationInfo: 'ข้อมูลการตรวจร่างกาย',
    editPhysicalExaminationInfo: 'แก้ไขข้อมูลการตรวจร่างกาย',
    diagnosisAndTreatment: 'การวินิจฉัยและการรักษา',
    beforeAfterImages: 'ภาพก่อน-หลัง',
    documents: 'เอกสาร',
    history: 'ประวัติการออกใบรับรองการรักษา',
    shortMedCertHistory: 'ประวัติการออกใบรับรองแพทย์ (อย่างย่อ)',
    otherImportantHistory: 'ประวัติอื่นที่สำคัญ',
    opdCreatedTime: 'เวลาสร้าง OPD'
  },
  header: {
    productList: 'รายการสินค้า',
    formulaList: 'รายการสูตรยา',
    serviceList: 'รายการบริการ',
    opdHistory: 'ประวัติ OPD',
    opdHistoryDetail: 'รายละเอียดประวัติ OPD',
    comment: 'ความเห็น',
    opinion: 'มีความเห็นว่า',
    summaryOpinion: 'สรุปความเห็น',
    docs: 'เอกสาร',
    beforeAfter: 'ภาพก่อน-หลัง',
    dateDdMmYy: 'วัน/เดือน/ปี',
    commenter: 'ผู้คอมเมนต์',
    no: 'ลำดับ',
    date: 'วันที่รับยา',
    ref: 'เอกสารอ้างอิง',
    medicinPrice: 'ค่ายา (บาท)',
    buyDate: 'วันที่ซื้อ',
    expiraDate: 'วันหมดอายุ',
    price: 'ราคา (บาท)',
    beforeImg: 'ภาพก่อนรักษา',
    afterImg: 'ภาพหลังรักษา',
    addBy: 'เพิ่มโดย',
    size: 'ขนาด'
  },
  label: {
    openNewOpd: 'เปิด OPD ใหม่',
    registerPatient: 'ลงทะเบียนคนไข้',
    orderMedicine: 'สั่งจัดยา',
    qty: 'จำนวน',
    deleteOPD: 'ลบข้อมูล OPD',
    weight: 'น้ำหนัก',
    KG: '(กิโลกรัม)',
    G: 'กรัม',
    kg: 'กก',
    height: 'ส่วนสูง',
    CM: '(เซนติเมตร)',
    cm: '(ซม.)',
    bmi: 'BMI',
    bloodPressure: 'ความดันโลหิต',
    SYS: 'ค่าสูง (SYS)',
    DIA: 'ค่าต่ำ (DIA)',
    heartRate: 'อัตราการเต้นหัวใจ',
    breathing: 'อัตราการหายใจ',
    healthConditionNormal: 'สภาพร่างกายทั่วไปอยู่ในเกณฑ์',
    temperature: 'อุณหภูมิ',
    diagnosis: 'การวินิจฉัย',
    symptom: 'อาการ',
    bloodPressureMmHg: 'มม.ปรอท. ชีพจร',
    editSymptom: 'แก้ไขอาการ',
    treatment: 'การรักษา',
    treatmentDetail: 'รายละเอียดการรักษา',
    treatmentPlan: 'รายละเอียด/แผนการรักษา',
    recommendation: 'คำแนะนำ',
    addTo: 'เพิ่มอาการในใบรับรองแพทย์ / ใบรับรองแพทย์ (อย่างย่อ) / ใบรับรองการรักษา',
    createBy: 'สร้างโดย',
    createDate: 'วันที่สร้าง',
    editBy: 'แก้ไขโดย',
    editDate: 'วันที่แก้ไข',
    doctroComment: 'ความเห็นแพทย์',
    title: 'หัวเรื่อง',
    content: 'เนื้อหา',
    chiefComplaint: 'อาการหลัก (CC)',
    file: 'แนบไฟล์',
    productsAndFormulas: 'สินค้าและสูตรยาที่จ่าย',
    service: 'บริการ',
    onlyOpd: 'เฉพาะรูปใน OPD นี้',
    nomalRoom: 'ห้องทั่วไป',
    exRoom: 'ห้องตรวจ',
    nomalRoomList: 'รายการห้องทั่วไป',
    exRoomList: 'รายการห้องตรวจ',
    have: 'มี',
    notHave: 'ไม่มี'
  },
  placeholder: {
    searchOPD: 'ค้นหาหมายเลข OPD',
    enterEmail: 'กรอกอีเมล',
    weight: 'กรอกน้ำหนัก',
    KG: '(กิโลกรัม)',
    kg: '(กก.)',
    height: 'กรอกส่วนสูง',
    CM: '(เซนติเมตร)',
    cm: '(ซม.)',
    bmi: 'BMI',
    bloodPressure: 'กรอกความดันโลหิต',
    heartRate: 'กรอกอัตราการเต้นหัวใจ',
    breathing: 'กรอกอัตราการหายใจ',
    temperature: 'กรอกอุณหภูมิ',
    diagnosis: 'กรอกการวินิจฉัย',
    symptom: 'กรอกอาการ',
    searchSymptom: 'ค้นหาอาการ',
    treatment: 'กรอกการรักษา',
    treatmentDetail: 'กรอกรายละเอียดการรักษา',
    recommendation: 'กรอกคำแนะนำ',
    createBy: 'สร้างโดย',
    createDate: 'กรอกวันที่สร้าง',
    editBy: 'กรอกแก้ไขโดย',
    editDate: 'กรอกวันที่แก้ไข',
    title: 'กรอกหัวเรื่อง',
    content: 'กรอกเนื้อหา',
    chiefComplaint: 'อาการหลัก (CC)',
    file: 'แนบไฟล์',
    beforeAfter: 'เพิ่มภาพก่อน/หลัง',
    docs: 'เพิ่มเอกสาร',
    selectDocs: 'เลือกเอกสาร',
    searchDocs: 'ค้นหาเอกสาร',
    selectedPaperSize: 'เลือกขนาดกระดาษ',
    signatureFile: 'เลือกไฟล์ลายเซ็น',
    preTreatmentImageFile: 'เลือกไฟล์รูปภาพก่อนการรักษา',
    postTreatmentImageFile: 'เลือกไฟล์รูปภาพหลังการรักษา'

  },
  alert: {
    deleteConfirm: 'ยืนยันการลบ OPD',
    deleteInfo1: 'คุณกำลังลบ OPD',
    deleteInfo2: 'ต้องการดำเนินการต่อหรือไม่',
    deleteSuccess: 'ลบ OPD สำเร็จ !',
    orderMedicineConfirm: 'ยืนยันการสั่งจัดยา',
    orderMedicineInfo1: 'คุณกำลังสั่งจัดยาให้กับ OPD',
    openNewOpdConfirm: 'ยืนยันการเปิด OPD ใหม่',
    openNewOpdInfo1: 'คุณกำลังเปิด OPD ใหม่',
    registerPatientConfirm: 'ยืนยันการลงทะเบียนคนไข้',
    registerPatientInfo1: 'คุณกำลังลงทะเบียนคนไข้ใหม่',
    running: 'กำลังดำเนินการ !'
  },
  toolTip: {
    openNewOpd: '*กรณีที่ต้องการเลือกผู้ได้รับ ค่ามือ/DF เลือกที่รายการสินค้า/บริการด้านบน',
    nomalRoom: 'ดูข้อมูลห้องทั่วไป',
    exRoom: 'ดูข้อมูลห้องตรวจ'
  },
  modal: {
    editBeforeAfter: 'แก้ไขภาพก่อน/หลัง',
    confirmDelete: 'ยืนยันการลบภาพก่อน/หลัง',
    deleteImage: 'ลบภาพก่อน/หลัง',
    deleteImageInfo1: 'คุณกำลังลบภาพก่อน/หลัง',
    deleteImageInfo2: 'ต้องการดำเนินการต่อหรือไม่',
    confirmDeleteDocs: 'ยืนยันการลบ เอกสาร',
    deleteDocsInfo1: 'คุณกำลังลบเอกสาร?',
    delete: {
      room: 'ยืนยันการลบห้อง',
      roomSubTitle: 'คุณกำลังจะลบ'
    }
  }
}
